module.exports = __webpack_public_path__ + "static/media/bg_rectangle-long-dark-1.1cae0fe0.jpg";